

























































import {Component, Prop, Vue} from 'vue-property-decorator'
import CategoryItemListSorter from "@/components/ListSorter/CategoryItemListSorter.vue";
import DeliousItemsStore from "@/_common/api/store/modules/DeliousItemsStore";
import DeleteCategoryItemDialog from "@/components/Dialog/DeleteCategoryItemDialog.vue";
import CategoryItemsStore from "@/_common/api/store/modules/CategoryItemsStore";
import AddCategoryItemDialog from "@/components/Dialog/AddCategoryItemDialog.vue";
import ItemsStore from "@/_common/api/store/modules/ItemsStore";
import {Util} from "@/_global/utils";
import {DeliousApiUtil} from "@/_common/api/utils/delious_api_utils";
import CategoriesStore from "@/_common/api/store/modules/CategoriesStore";
import {CmsApiUtil} from "@/_common/api/utils/cms_api_utils";
import CondimentGroupsStore from "@/_common/api/store/modules/CondimentGroupsStore";

@Component({
    components: {
        AddCategoryItemDialog,
        DeleteCategoryItemDialog,
        CategoryItemListSorter,
    }
})
export default class CategoryItemList extends Vue {
    private isAddingItem = false;
    private deletingCategoryItemId = -1;

    get categoryId(): number {
        return Number(this.$route.params.categoryId);
    }

    get categoryNameJp(): string {
        // todo カテゴリーにもデフォルトの名称を持つようにする
        const category = CategoriesStore.categoryById[this.categoryId] || {};
        return CmsApiUtil.getName(category.names, "jp");
    }

    get deletingCategoryItem(): CMS.CategoryItem {
        return CategoryItemsStore.categoryItemById[this.deletingCategoryItemId];
    }

    get enableRegister(): boolean {
        const categoryItems: CMS.CategoryItem[] = CategoryItemsStore.categoryItemsByCategoryId[this.categoryId] || [];
        return categoryItems.length < 30;
    }

    // ソート
    private onChangeSort(sortedCategoryItemIds: number[]): void {
        CategoryItemsStore.localSort(sortedCategoryItemIds);
    }

    private onEndSort(): void {
        CategoryItemsStore.applySort(this.categoryId);
    }

    // 追加
    private onClickAddItem(): void {
        this.isAddingItem = true;
    }

    private onCancelAddCategoryItem(): void {
        this.isAddingItem = false;
    }

    private async onOkAddCategoryItem(categoryItems: CMS.CategoryItem[]) {
        // 登録済みの商品点数と合わせて30件を超える場合、超えた分の商品は配列から削除する。
        const registeredItems: CMS.CategoryItem[] = CategoryItemsStore.categoryItemsByCategoryId[this.categoryId] || [];
        if(registeredItems.length + categoryItems.length > 30){
            const delCount = registeredItems.length + categoryItems.length - 30;
            categoryItems.splice(categoryItems.length- delCount, delCount);
            alert("30件を超えた商品は追加されません");
        }
        // カテゴリー販売商品を登録
        await CategoryItemsStore.create(categoryItems);

        for (let i = 0; i < categoryItems.length; i++) {
            await CategoryItemsStore.addGroupItems(categoryItems[i].item_id);
        }
        this.isAddingItem = false;
    }

    // 削除
    private onSelectDelete(categoryItemid: number): void {
        this.deletingCategoryItemId = categoryItemid;
    }

    private onCancelDeleteCategoryItem(): void {
        this.deletingCategoryItemId = -1;
    }

    private onOkDeleteCategoryItem(): void {
        CategoryItemsStore.delete(this.deletingCategoryItemId);
        this.deletingCategoryItemId = -1;
    }

    // 表示・非表示 変更
    private onChangeActive(categoryItemId: number, visible: boolean): void {
        const target: CMS.CategoryItem = Util.deepCopy(CategoryItemsStore.categoryItemById[categoryItemId]);
        target.visible = visible;
        CategoryItemsStore.edit(target);
    }
}
